import { Button, createStyles, makeStyles, Paper, Slider, Theme, Typography } from '@material-ui/core';
import React, { useCallback, useRef, useState } from 'react';
import AvatarEditor from "react-avatar-editor"
import { useDropzone } from "react-dropzone"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
    content: {
        width: 600,
        height: 400,
        padding: theme.spacing(1),
    },
    dropbox: {
        border: "dashed 2px #333",
        widht: "100%",
        height: "100%",
    },
    dropboxActive: {
        border: "dashed 2px #333",
        backgroundColor: "#c8fac8",
        widht: "100%",
        height: "100%",
    },
    side: {
        display: "flex",
        flexDirection: "row",
    },
    control: {
        padding: theme.spacing(1),
        flexGrow: 1,
    },
    slider: {
        margin: "8px 16px",
    }
  }),
);

export interface Props {
    onSuccess?: (img: Blob, dataUrl: string)=>void | undefined
}

const AvatarUpload = (props: Props) => {

    const classes = useStyles()
    const [t] = useTranslation()

    const [file, setFile] = useState<File|undefined>()
    const [rotate, setRotate] = useState(0)
    const [scale, setScale] = useState(1)

    const editor = useRef<AvatarEditor>(null)

    const save = () => {
        if (editor) {
            const img = editor.current?.getImageScaledToCanvas()
            if (img) {
                const dataUri = img.toDataURL()
                editor.current?.getImageScaledToCanvas().toBlob((blob)=>blob && props?.onSuccess?.(blob, dataUri))
            }
        }
    }

    const onDrop = useCallback(files=>{
        files.length === 1 && setFile(files[0])
    }, [])

    const { getRootProps, getInputProps, isDragAccept } = useDropzone({
        onDrop,
        multiple: false,
        accept: "image/*",
    })

    return (
        <Paper className={classes.root}>
            <div className={classes.content}>
                { 
                file ? 
                <div>
                    <div className={classes.side}>
                        <AvatarEditor
                            ref={editor}
                            image={file}
                            width={256} 
                            height={256}
                            borderRadius={128}
                            rotate={rotate}
                            scale={scale}
                        />
                        <div className={classes.control}>
                            <div>
                                <Typography variant="body2">{t("message.avatarUpload.rotate")}</Typography>
                                <div className={classes.slider}>
                                    <Slider
                                        value={rotate}
                                        onChange={(e,v)=>typeof v == "number" && setRotate(v)}
                                        min={-180}
                                        max={180}
                                        getAriaValueText={v=>`${v}°`}
                                        step={5}
                                        marks={[-180,-90,0,90,180].map(v=>({value:v,label:`${v}°`}))}
                                    />
                                </div>
                            </div>
                            <div>
                                <Typography variant="body2">{t("message.avatarUpload.scale")}</Typography>
                                <div className={classes.slider}>
                                    <Slider
                                        value={scale}
                                        onChange={(e,v)=>typeof v == "number" && setScale(v)}
                                        min={1}
                                        max={3}
                                        getAriaValueText={v=>`${v}`}
                                        step={0.001}
                                        marks={[1,2,3].map(v=>({value:v,label:`${v}`}))}
                                    />
                                </div>
                            </div>
                            <Button variant="contained" color="primary" onClick={()=>save()}>
                                {t("message.avatarUpload.success")}
                            </Button>
                        </div>
                    </div>
                </div>
                : 
                <div {...getRootProps()} className={isDragAccept ? classes.dropboxActive : classes.dropbox}>
                    <input {...getInputProps() } />
                    <Typography variant="body2">{t("message.avatarUpload.dropHere")}</Typography>
                </div>
                }
            </div>
        </Paper>
    )
}

export default AvatarUpload